<div class="filters-shell" [class.collapsed]="!sidebarVisible()">
  <div class="filters-toggle">
    <p-button
      type="button"
      [icon]="sidebarVisible() ? 'pi pi-angle-left' : 'pi pi-angle-right'"
      [rounded]="true"
      severity="secondary"
      (onClick)="toggleSidebar()"
      pTooltip="Toggle filters"
      tooltipPosition="right"
    />
  </div>
  @if (sidebarVisible()) {
    <div class="filters-body">
      <p-panel header="Range & app" [toggleable]="false">
        <div class="field">
          <label for="wa-app-id">App ID</label>
          <p-select
            inputId="wa-app-id"
            [(ngModel)]="appId"
            [options]="appIdOptions()"
            optionLabel="label"
            optionValue="value"
            [loading]="appIdLoading()"
            placeholder="All apps"
            appendTo="body"
            [fluid]="true"
            (onChange)="onAppIdUserChange()"
          />
        </div>
        <div class="field">
          <label for="wa-range">Date range (UTC)</label>
          <p-datepicker
            inputId="wa-range"
            [(ngModel)]="dateRange"
            selectionMode="range"
            [readonlyInput]="true"
            [showIcon]="true"
            dateFormat="yy-mm-dd"
            placeholder="Start — End"
            [fluid]="true"
          />
        </div>
        <div class="preset-row">
          <p-button
            type="button"
            label="Today"
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="presetToday()"
          />
          <p-button
            type="button"
            label="7d"
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="presetLastDays(7)"
          />
          <p-button
            type="button"
            label="30d"
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="presetLastDays(30)"
          />
          <p-button
            type="button"
            label="Month"
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="presetThisMonth()"
          />
        </div>
      </p-panel>

      <p-panel
        header="Slice data (substring, case-insensitive)"
        [toggleable]="true"
        [collapsed]="false"
        class="filters-panel-dim"
      >
        <p class="panel-hint">
          Narrows all charts and counts. Leave blank for full range.
        </p>
        <div class="field">
          <label for="wa-f-type">Event type</label>
          <input
            pInputText
            id="wa-f-type"
            type="text"
            [(ngModel)]="filterEventType"
            placeholder="e.g. page_view, api_request"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-path">Path contains</label>
          <input
            pInputText
            id="wa-f-path"
            type="text"
            [(ngModel)]="filterPath"
            placeholder="Substring of URL path"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-user">Username</label>
          <input
            pInputText
            id="wa-f-user"
            type="text"
            [(ngModel)]="filterUsername"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-country">Country</label>
          <input
            pInputText
            id="wa-f-country"
            type="text"
            [(ngModel)]="filterCountry"
            placeholder="ISO code or name"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-city">City</label>
          <input
            pInputText
            id="wa-f-city"
            type="text"
            [(ngModel)]="filterCity"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-browser">Browser</label>
          <input
            pInputText
            id="wa-f-browser"
            type="text"
            [(ngModel)]="filterBrowser"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-os">OS</label>
          <input
            pInputText
            id="wa-f-os"
            type="text"
            [(ngModel)]="filterOs"
            class="w-full"
          />
        </div>
        <div class="field">
          <label for="wa-f-device">Device</label>
          <input
            pInputText
            id="wa-f-device"
            type="text"
            [(ngModel)]="filterDevice"
            placeholder="mobile, tablet, desktop"
            class="w-full"
          />
        </div>
      </p-panel>

      <p-button
        label="Apply"
        icon="pi pi-filter"
        (onClick)="apply()"
        class="w-full apply-btn"
      />
    </div>
  }
</div>
